import Question from './Question'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

export default ({ checklistId, actionId }) => {
    const act = useAct()
    const questionIds = useSelector(s => _.orderBy(_.values(s.questions.entities).filter(q => q.actionId === actionId), 'questionOrder').map(q => q.id))
    const { adding } = useSelector(s => s.scriptEditor)
    const softLoad = useSelector(s => _.values(s.questions.entities).length > 25)

    useEffect(() => {
        if (actionId) {
            act.scriptEditor.clear()
            act.scriptEditor.load(checklistId, actionId)
        }
    }, [actionId])

    return <div className='script-editor'>
        <DndProvider backend={HTML5Backend}>
            <div className='questions'>
                {questionIds.map(id => <Question actionId={actionId} softLoad={softLoad} id={id} key={id} />)}
            </div>

            <a className='button secondary margin-top' onClick={() => act.scriptEditor.setAdding(!adding)}>Add question</a>

            {adding &&
                <div className='popup popup-list add-question-popup'>
                    <div className='add-question-columns'>
                        <div>
                            <div className='group'>
                                <div className='name'>Ask</div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'multiple_choice', actionId })}>
                                    Multiple choice
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'multi_select', actionId })}>
                                    Multi-select
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'rating', actionId })}>
                                    Rating
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'text', actionId })}>
                                    Text
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'number', actionId })}>
                                    Number
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'date', actionId })}>
                                    Date
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='group'>
                                <div className='name'>Collect</div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'email', actionId })}>
                                    Personal email
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'phone', actionId })}>
                                    Phone number
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'school', actionId })}>
                                    School
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'address', actionId })}>
                                    Address
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'file', actionId })}>
                                    File upload
                                </div>
                            </div>
                            <div className='group'>
                                <div className='name'>Content</div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'instruction', actionId })}>
                                    Instruction
                                </div>
                                <div className='filter' onClick={() => act.scriptEditor.questions.add({ inputType: 'download', actionId })}>
                                    File download
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </DndProvider>
    </div>
}
